import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  App, Content,
  Events,
  IonicPage, ModalController,
  NavController,
  NavParams,
  Platform
} from 'ionic-angular';
import {AppModuleDetailsPage} from "../app-module-details/app-module-details";
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {CourseModule} from "../../models/course-module";
import {AppVideoQuizPage} from "../app-video-quiz/app-video-quiz";
import {AppVideoMyWayPage} from "../app-video-my-way/app-video-my-way";
import {AppStepUpdatePage} from "../app-step-update/app-step-update";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {UserTagProvider} from "../../providers/user-tag/user-tag";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {StepCounterEngineProvider} from "../../providers/step-counter-engine/step-counter-engine";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppWhoQuestionnairePage} from "../app-who-questionnaire/app-who-questionnaire";
import {AppFeedbackPage} from "../app-feedback/app-feedback";
import {Push, PushObject, PushOptions} from "@ionic-native/push";
import {AppStatsPage} from "../app-stats/app-stats";
import {ApiProvider} from "../../providers/api/api";
import {AppVideoPlayerPage} from "../app-video-player/app-video-player";
import {PopupUpdateGoalProvider} from "../../providers/popup-update-goal/popup-update-goal";
import {ChatStateProvider} from "../../providers/chat-state/chat-state";
import {SplashScreen} from "@ionic-native/splash-screen";
import {AppSettingsTrainingPopupPage} from "../app-settings-training-popup/app-settings-training-popup";
import {AppPopupEvaluationPage} from "../app-popup-evaluation/app-popup-evaluation";
import {AppPopupEvaluationMailSentPage} from "../app-popup-evaluation-mail-sent/app-popup-evaluation-mail-sent";
import {AppChatPage} from "../app-chat/app-chat";
import {AppForumListPage} from "../app-forum-list/app-forum-list";
import {AppForumTopicsPage} from "../app-forum-topics/app-forum-topics";
import {AppChatDetailsPage} from "../app-chat-details/app-chat-details";

/**
 * Generated class for the AppModuleListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-module-list',
  templateUrl: 'app-module-list.html',
})
export class AppModuleListPage {
  @ViewChild(Content) public content: Content;

  moduleDetailsPage: any = AppModuleDetailsPage;

  courseData: Array<CourseModule>;

  progress: number = 0;
  videosClosed: number = 0;
  videosReady: number = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    protected courseDataProvider: ApiCourseDataProvider,
    public progressData: UserProgressStateProvider,
    public alertCtrl: AlertController,
    private app: App,
    private tag: UserTagProvider,
    private userState: UserStateProvider,
    private stepCounterEngine: StepCounterEngineProvider,
    private contentTranslation: ContentTranslationProvider,
    private events: Events,
    private push: Push,
    public platform: Platform,
    public api: ApiProvider,
    protected popupUpdateGoalProvider: PopupUpdateGoalProvider, //initialization needed
    protected chatState: ChatStateProvider, //initialization needed
    public splash: SplashScreen,
    // public modalCtrl: ModalController,
    public progressProvider: UserProgressStateProvider

  ) {
    this.courseData = [];

    this.popupUpdateGoalProvider.setNavController(this.navCtrl);

    this.events.subscribe('app:open-video-plus', e => {
      console.log('openVideoPlus event', e);
      if(e.video) {
        this.app.getActiveNav().push(AppVideoPlayerPage, e.video).then();
      }
    })
  }

  ionViewWillLoad() {
    this.push.hasPermission().then((res: any) => {
      if (res.isEnabled) {
        console.log('push plugin enabled', res);
      } else {
        console.log('push plugin not enabled', res);
      }
    })

    const options: PushOptions = {
      android: {},
      ios: {
        alert: 'true',
        badge: true,
        sound: 'true'
      },
      windows: {}
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => {
      console.log('Received a notification', notification)

      if (notification.additionalData && notification.additionalData.type == 'activity') {
        this.navCtrl.parent.select(2);
      }
      if (notification.additionalData && notification.additionalData.type == 'chat') {
        this.navCtrl.parent.select(5);
        this.navCtrl.parent.getByIndex(5).push(AppChatDetailsPage, this.userState.user.id);
      }
      if (notification.additionalData && notification.additionalData.type == 'forum') {
        this.navCtrl.parent.select(5);
        this.navCtrl.parent.getByIndex(5).push(AppForumListPage, {redirection: notification.additionalData});
      }
    });

    pushObject.on('registration').subscribe((registration: any) => {
      this.api.callPost('/users/' + this.userState.user.id + "/pushToken", {
        token: registration.registrationId,
        platform: this.platform.navigatorPlatform
      }).subscribe(_resp => {
      })

    });

    pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));

    // let modal = this.modalCtrl.create(AppPopupEvaluationMailSentPage, {}, {cssClass: 'modal-alert ip-alert ip-with-close ip-training-notifications-popup app-modal-popup'});
    // modal.present().then();

  }

  showMotivationalMessage() {
    console.log('show message', this);
    if (this.progressData.currentProgress && !this.progressData.currentProgress.messageShown && this.progressData.currentProgress.video && this.progressData.currentProgress.video._userMotivationalMessage) {
      var message = this.tag.compile(this.progressData.currentProgress.video._userMotivationalMessage, {});
      if (message.indexOf('{') > -1 && this.progressData.currentProgress.video._userMotivationalFallbackMessage) {
        message = this.tag.compile(this.progressData.currentProgress.video._userMotivationalFallbackMessage, {});
      }
      var video = this.progressData.currentProgress.video;
      var app = this.app;
      var alert = this.alertCtrl.create({
        message: '<div class="motivational-message-content">'+message+"</div>",
        buttons: [
          {
            text: this.contentTranslation.translateContent('ETAPPE STARTEN').toUpperCase(),
            handler: () => {
              // user has clicked the alert button
              // begin the alert's dismiss transition
              alert.dismiss(null, null, {
                animate: false
              });

              return false;
            }
          }
        ],
        cssClass: 'ip-alert pushup-design motivational-message-design'
      });
      alert.present();
      this.progressData.currentProgress.messageShown = true;
      this.progressData.triggerProgressUpdate();


      alert.onDidDismiss(() => {
        setTimeout(function () {
          if (video.extraAction == 'feedback') {
            app.getRootNav().push(AppFeedbackPage);
          }
          if (video.extraAction == 'who') {
            app.getRootNav().push(AppWhoQuestionnairePage);
          }
        }, 3000);
      });
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppModuleListPage');
    var me = this;

    var loadData = () => {
      this.courseDataProvider.getCourseData().then(data => {
        this.splash.hide();

        let currentModule = 0;

        me.videosClosed = me.videosReady = 0;
        me.courseData = data;
        me.courseData.map((module: CourseModule) => {
          if (module.type != 'normal') {
            return;
          }
          me.videosClosed += (module._userStatus == 3 || module._userClosed == module.videos.length) ? 1 : 0;
          me.videosReady += 1;
          if(module._userStatus == 2) {
            currentModule = module.position;
          }
        });

        if (me.videosReady > me.videosClosed) {
          me.courseData.filter((module: CourseModule) => {
            if(module.type == 'farewell') {
              module._userStatus = 1;
            }
          })
        }

        // console.log('load data', this.navCtrl.last());
        // this.showUpdateGoalMessage();
        // this.showMotivationalMessage();

        if(this.userState.user.introWatched || currentModule > 1) {
          setTimeout(() => {
            if(currentModule) {
              this.content.scrollTo(0, 108 + currentModule*436, 0).then(() => {
                console.log('scrolled');
              });
            }
          }, 10);
        }

      });

    }
    loadData();

    this.events.subscribe('state:refreshed', () => {
      loadData();
    })
    this.events.subscribe('app:show-motivational-message', () => {
      this.showMotivationalMessage();
    })


    if (this.userState.user.stepCounterEngine) {
      this.stepCounterEngine.getEngine(this.userState.user.stepCounterEngine).makeSync((new Date().toISOString()).substr(0, 10)).then().catch(function (e) {
        console.log('sync error', e);
      });
    }

  }

  goToModule(module) {
    if (module.type != 'normal' && module.videos.length === 1 && module._userStatus != 1) {
      this.navCtrl.push(AppVideoPlayerPage, module.videos[0]);
      return;
    }

    console.log('goToModule', module.videos[0]);
    this.showUpdateGoalMessage();
    this.showMotivationalMessage();

    if (module._userStatus == 1) {
      return;
    }
    this.navCtrl.push(this.moduleDetailsPage, module);
  }

  showUpdateGoalMessage() {
    if(this.progressData.currentProgress && !this.progressData.currentProgress.messageShown && this.progressData.currentProgress.video && this.progressData.currentProgress.video.position == 0 && this.progressData.currentProgress.video.module.position > 1) {
      this.events.publish('app:show-update-goal-popup', {moduleId: this.progressData.currentProgress.video.module.id});
    }
  }

  showModuleNotAvailable() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Wann beginnt Ihre nächste Etappe?'),
      subTitle: this.contentTranslation.translateContent('Jede Etappe hat eine Dauer von 7 Tagen. \n' +
        'In diesem Zeitraum haben Sie die Möglichkeit die Anregungen, Tipps und Übungen mit Ivonne auszuprobieren und in Ihren Wochenalltag einzubauen.'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();


  }

}



// WEBPACK FOOTER //
// ./src/pages/app-module-list/app-module-list.ts